import { Button as MaterialButton, Grid, Theme, Typography, withStyles } from '@material-ui/core';
import { BlocMaintenance, Button, Card, Modale } from 'bc-front-sagacomponents';
import { isMobile } from 'mobile-device-detect';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useReactPWAInstall } from '../../../components/InstallApp';
import { buildMenuResponsive } from '../../../helpers/datas';
import useWindowDimensions from '../../../hooks/useWindowDimension';
import Depannage from '../../../images/Depannage';
import Download from '../../../images/Download';
import IllustrationSagaSvg from '../../../images/illustration-saga';
import { setMenuResponsive } from '../../../redux/GlobalRedux';
import { AdherentParticulierResponse, CompteParticulier, Fidelite } from '../../../services/Api/swagger';
import {
  getMsgMaintenanceDateDebut,
  getMsgMaintenanceDateFin,
  getMsgMaintenanceEn,
  getMsgMaintenanceFr,
} from '../../../services/Config';
import history from '../../../services/history';
import BlocContact from '../BlocContact';
import BlocFidelite from '../BlocFidelite';
import { useProgrammes } from '../hooks/useProgrammes';
import MenuPro from '../MenuPro';
import AjoutAdherent from '../MenuPro/AjoutAdherent';
import CarteFidelite from '../MenuPro/CarteFidelite';
import styles from '../style';

interface Props {
  classes?: any;
  theme?: Theme;
  infoCompte?: CompteParticulier;
  listeAdherents?: AdherentParticulierResponse[];
  listeCompteFidelite?: Fidelite[];
}
const HomePageContent = (props: Props) => {
  const { classes, theme, infoCompte, listeAdherents, listeCompteFidelite } = props;

  const {
    listeAdhesions,
    fetchingProgramme,
    errorProgramme,
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRemorquageDepannage,
    hasRenouvellemement,
    hasResiliation,
    infoAssisteur,
    fetchingAssisteur,
    errorAssisteur,
  } = useProgrammes();

  const maintenanceFr = getMsgMaintenanceFr();
  const maintenanceEn = getMsgMaintenanceEn();
  const dateDebutMaintenanceMsg = getMsgMaintenanceDateDebut();
  const dateFinMaintenanceMsg = getMsgMaintenanceDateFin();
  const { width } = useWindowDimensions();
  //   const authenticated = isAuthenticated();

  const menuResponsive = buildMenuResponsive(
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRenouvellemement,
    hasResiliation,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setMenuResponsive(menuResponsive));
  }, [menuResponsive]);

  const [openAjoutAdherent, setOpenAjoutAdherent] = useState<boolean>(false);

  // PWA display & installation
  const [openInfoApp, setOpenInfoApp] = useState<boolean>(false);
  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
  const handleInstall = () => {
    pwaInstall({
      title: "Installer l'application mobile",
      description: 'SAGA pour les particuliers',
    })
      .then(() => console.log('ok'))
      .catch(() => console.log('ok'));
  };

  return (
    <>
      <div className={classes.homePage}>
        <div className={classes.title}>
          <Typography variant="h1">
            <>
              <strong>Bonjour</strong> {infoCompte && infoCompte.prenom} !
            </>
          </Typography>
          {supported() && !isInstalled() && isMobile && (
            <Button
              icon={<Download fill="white" />}
              variant="contained"
              color="secondary"
              onClick={handleInstall}
              title="Installer l'application"
            />
          )}
          {!isMobile && (
            <Button
              icon={<Download fill="white" />}
              variant="contained"
              color="secondary"
              onClick={() => setOpenInfoApp(true)}
              title="Installer l'application"
            />
          )}
        </div>
        <div className={classes.contentBloc}>
          <div>
            <BlocMaintenance
              msgMaintenanceFr={maintenanceFr || ' '}
              msgMaintenanceEn={maintenanceEn || ' '}
              dateDebutMsgMaintenance={dateDebutMaintenanceMsg || ' '}
              dateFinMsgMaintenance={dateFinMaintenanceMsg || ' '}
            />
            {width <= 628 && hasRemorquageDepannage && (
              <Card red className={classes.containerButtonDepannage}>
                <MaterialButton
                  color="primary"
                  classes={{
                    label: classes.buttonDepannageLabel,
                  }}
                  onClick={() => history.push('/depannage')}
                >
                  <Depannage width={55} height={33} />
                  <span className={classes.buttonDepannageTexte}>Lancer le dépannage</span>
                </MaterialButton>
              </Card>
            )}{' '}
            <div className={classes.content}>
              <BlocFidelite listeCompteFidelite={listeCompteFidelite} hasServiceFidelisation={hasServiceFidelisation} />
              <BlocContact infoAssisteur={infoAssisteur} />
            </div>
          </div>
          {width > 628 && (
            <MenuPro
              listeAdhesions={listeAdhesions}
              hasServiceFidelisation={hasServiceFidelisation}
              hasListeProduits={hasListeProduits}
              hasRemboursement={hasRemboursement}
              hasRemorquageDepannage={hasRemorquageDepannage}
              setOpenAjoutAdherent={setOpenAjoutAdherent}
              hasRenouvellemement={hasRenouvellemement}
              hasResiliation={hasResiliation}
            />
          )}
        </div>
        {width <= 628 && <CarteFidelite listeAdherents={listeAdherents} />}
        <AjoutAdherent openAjoutAdherent={openAjoutAdherent} setOpenAjoutAdherent={setOpenAjoutAdherent} />
      </div>
      {width > 628 && (
        <div className={classes.illuHome}>
          <IllustrationSagaSvg
            color1={theme ? theme.palette.secondary.main : ''}
            color2={theme ? theme.palette.secondary.light : ''}
          ></IllustrationSagaSvg>
        </div>
      )}
      <Modale open={openInfoApp} onCancel={() => setOpenInfoApp(false)} title=" ">
        <Grid item className={classes.modaleInstallApp}>
          <Typography variant="h3">Installation de l'application</Typography>
          <Typography variant="body2">
            L’application ou Web App Saga est <strong>disponible pour votre smartphone ou votre tablette</strong> sous
            Android et sous iOS, elle vous permet l’accès aux mêmes fonctionnalités que le site internet tout en gagnant
            en confort d’utilisation et en fluidité, de plus, elle vous permet un
            <strong> accès hors ligne.</strong>
          </Typography>
          <Typography variant="body2">
            Vous trouverez la procédure d’installation pour chacun de ces systèmes d’exploitation.
          </Typography>
          <br />
          <Typography variant="body2">
            <strong>Pour iOS et iPadOS:</strong>
            <br />
            Rendez-vous sur safari, puis sur <a href="https://part.sagaenligne.fr">part.sagaenligne.fr</a>
            <br />
            Cliquez sur le bouton <strong>“Installer l’application”</strong> et suivez les instructions qui s’affichent.{' '}
          </Typography>
          <br />
          <Typography variant="body2">
            <strong>Pour Android:</strong>
            <br />
            Rendez-vous sur votre navigateur internet, puis sur{' '}
            <a href="https://part.sagaenligne.fr">part.sagaenligne.fr</a>.
            <br />
            Cliquez sur le bouton <strong>“Installer l’application”</strong> et suivez les instructions qui s’affichent.{' '}
          </Typography>
        </Grid>
      </Modale>
    </>
  );
};

export default withStyles(styles)(HomePageContent);
